import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import { Form, Select, Card, Spin, Row, Col } from 'antd';
import { ApiCaller, Utils } from '../../config';

const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

const SuperAdminWorkWeekSettings = forwardRef((props, ref) => {
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    useEffect(() => {
        const fetchSettings = async () => {
            setLoading(true);
            try {
                const res = await ApiCaller.Get('/superadmin/work-week-settings');
                if (res.data?.data) {
                    form.setFieldsValue({
                        workWeekStartDay: res.data.data.workWeekStartDay || 'Sunday',
                        workWeekEndDay: res.data.data.workWeekEndDay || 'Saturday',
                    });
                }
            } catch (e) {
                // Ignore error if endpoint doesn't exist yet
            } finally {
                setLoading(false);
            }
        };
        fetchSettings();
    }, [form]);

    useImperativeHandle(ref, () => ({
        save: async () => {
            try {
                const values = await form.validateFields();
                await ApiCaller.Patch('/superadmin/work-week-settings', values);
                return true;
            } catch (e) {
                if (e.errorFields) {
                    // Form validation failed
                    return false;
                }
                Utils.showMessage('error', e?.response?.data?.message || 'Failed to update work week settings');
                throw e; // throw so parent can stop loading
            }
        }
    }));

    if (loading) return <Spin />;

    return (
        <Card title="Global Work Week Settings" bordered={false} style={{ maxWidth: '100%' }}>
            <Form form={form} layout="vertical">
                <Row gutter={24}>
                    <Col xs={24} md={12}>
                        <Form.Item name="workWeekStartDay" label="Global Work Week Start Day" rules={[{ required: true }]}>
                            <Select>
                                {daysOfWeek.map(day => <Select.Option key={day} value={day.toLowerCase()}>{day}</Select.Option>)}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item name="workWeekEndDay" label="Global Work Week End Day" rules={[{ required: true }]}>
                            <Select>
                                {daysOfWeek.map(day => <Select.Option key={day} value={day.toLowerCase()}>{day}</Select.Option>)}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Card>
    );
});

export default SuperAdminWorkWeekSettings;
